import React from 'react';
import { Pressable, View } from 'react-native';
import Modal from 'react-native-modal';
import colors from '~/assets/themes/colors';

import CloseSVG from '~/assets/svgs/close.svg';
import WarningSVG from '~/assets/svgs/warning.svg';
import { Button, Text } from '~/components';

interface Props {
  visible: boolean;
  message: string;
  onContinue: () => void;
  onClose: () => void;
}

const NoDataFoundModal: React.FC<Props> = ({
  visible,
  message,
  onContinue,
  onClose,
}) => {
  return (
    <Modal
      isVisible={visible}
      className={'items-center justify-center'}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
      onSwipeComplete={() => onClose()}
      swipeDirection={['down']}
      propagateSwipe
    >
      <View className="items-center justify-center flex-1 px-6">
        <View className="bg-white p-6 rounded-2xl w-full">
          <Pressable className=" items-end" onPress={() => onClose()}>
            <CloseSVG color={colors.gray[400]} width={24} height={24} />
          </Pressable>

          <View className="items-center mb-6 p-3 rounded-full bg-secondary-200 mx-auto">
            <WarningSVG color={'#ACABAB'} width={26} height={26} />
          </View>

          <Text className="text-center text-xl mb-4 text-gray-600">
            {message}
          </Text>

          <Text className="text-center text-sm mb-6 text-gray-400">
            Deseja continuar?
          </Text>

          <View className="flex-column space-y-4">
            <Button
              onPress={() => {
                onClose();
                onContinue();
              }}
            >
              Continuar
            </Button>

            <Button variant="tertiary" onPress={() => onClose()}>
              VOLTAR
            </Button>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default NoDataFoundModal;
